import axios from 'axios'

class TermsConditionsService {
  getTermsConditions = () =>
    axios({
      url: 'terms-conditions/admin/list',
      method: 'GET',
    })

  createTermsConditions = (data) =>
    axios({
      url: 'terms-conditions/admin',
      method: 'POST',
      data,
    })

  updateTermsConditions = (id, data) =>
    axios({
      url: `terms-conditions/admin/${id}`,
      method: 'PUT',
      data,
    })

  deleteTermsConditions = (id) =>
    axios({
      url: `terms-conditions/admin/${id}`,
      method: 'DELETE',
    })
}

export default new TermsConditionsService()
